import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(to right, #f0f9ff, #c9efff);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 3rem 1rem;
`;


export const BookSessionContainer = styled.div`
  background-color: #96DBF8;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px; /* LIMIT width for readability */
`;


export const BookSessionSubHeading = styled.div`
  color: #333;
  font-family: 'Nunito', sans-serif;
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
`;

export const Form = styled.form`
  width: 100%;
`;

export const FormGroup = styled.div`
  margin-bottom: 1.25rem;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 0.9rem 1rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  font-family: 'Nunito', sans-serif;
  transition: box-shadow 0.2s;

  &::placeholder {
    color: #aaa;
  }

  &:focus {
    box-shadow: 0 0 0 3px rgba(100, 181, 246, 0.5);
    border-color: #64B5F6;
  }

  &[type="textarea"], &.textarea {
    min-height: 120px;
    resize: vertical;
  }
`;

FormInput.defaultProps = {
  as: 'input'
};
